import React from "react";
import { ListItemText } from "@material-ui/core";
import SimpleTable from "../../components/SimpleTable";
import Time from "../../lithic/Moment";

export const InviteesList = ({ invitees }) => {
  if (!invitees) return null;

  return (
    <SimpleTable
      headers={["Id", "Name", "Email", "Status", "Created at"]}
      rows={invitees}
      keyRowAttr="id"
      toCells={(invitee) => [
        <a href={invitee.applicationLink} target="_blank" rel="noreferrer">
          {invitee.id}
        </a>,
        <ListItemText key={2}>{invitee.name}</ListItemText>,
        <ListItemText key={4}>{invitee.email}</ListItemText>,
        <ListItemText key={5}>
          {invitee.active ? "Active" : "Inactive"}
        </ListItemText>,
        <Time key={7} formatExact="MMM DD, YYYY HH:mm:ss">
          {invitee.createdAt}
        </Time>
      ]}
    />
  );
};
